import { useEvent } from "../../../context/EventContext";
import MainEventForm from "./mainEvent/mainEventForm";
import MainEventPreview from "../OrganizerDashboard/mainEvent/MainEventFormPreview";
import { useState } from "react";

// A component to handle the main event form and MainEventPreview.
const MainEvent = ({ onNext }) => {
  const { formData } = useEvent();
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  //   Handles the "Edit" button click in the main event form.
  //   * Sets `isFormVisible` to `true`, which displays the main event form.
  const handleEdit = (editMode) => {
    setIsFormVisible(true);
    setIsEditing(editMode);
  };

  return (
    <div className="main-event">
      {formData._id === undefined ? (
        <MainEventForm setIsFormVisible={setIsFormVisible} />
      ) : !isFormVisible ? (
        <MainEventPreview onEdit={handleEdit} onNext={onNext} />
      ) : (
        <MainEventForm
          setIsFormVisible={setIsFormVisible}
          isEditing={isEditing}
        />
      )}
    </div>
  );
};

export default MainEvent;
